import LogoutIcon from "../../../styles/svg/logout.svg";
import userIcon from "../../../styles/svg/users-icon-2.svg";
import workflowIcon from "../../../styles/svg/worklog-settings.svg";
import missingStatusIcon from "../../../styles/svg/missing-status-report-icon.svg";
import boardsIcon from "../../../styles/svg/boards-icon.svg";
import SupportIcon from "../../../styles/svg/support.svg";
import mergeBoardIcon from "../../../styles/svg/merge.svg";
import systemSettingIcon from "../../../styles/svg/systemSettingIcon.svg";

export const profileMenuList = [
  {
    id: "feedback",
    label: "Help & Feedback",
    icon: SupportIcon,
    permission: "all", // visible to all users
    className: "",
    alt: "feedback",
  },
  {
    id: "manageUsers",
    label: "Manage Users",
    icon: userIcon,
    permission: "admin",
    className: "",
    alt: "user",
    path: "/admin-user?users-status=active",
  },
  {
    id: "manageBoards",
    label: "Manage Boards",
    icon: boardsIcon,
    permission: "admin",
    className: "",
    alt: "board",
    path: "/admin-board?boards-type=active",
  },
  {
    id: "workflowSettings",
    label: "Workflows Settings",
    icon: workflowIcon,
    permission: "admin",
    className: "",
    alt: "workflow",
    path: "/admin-workflow",
  },
  {
    id: "missingStatus",
    label: "Missing Status Report",
    icon: missingStatusIcon,
    permission: "admin",
    className: "",
    alt: "missing status",
  },
  {
    id: "mergeBoard",
    label: "Merge Board",
    icon: mergeBoardIcon,
    permission: "admin",
    className: "",
    alt: "merge board",
  },
  {
    id: "systemSettings",
    label: "System Settings",
    icon: systemSettingIcon,
    permission: "admin",
    className: "",
    alt: "system setting",
    path: "/system-setting",
  },
  {
    id: "logout",
    label: "Logout",
    icon: LogoutIcon,
    permission: "all",
    className: "",
    alt: "log out",
  },
];
